import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../environments/environment';

export const backendUrlInterceptor: HttpInterceptorFn = (req, next) => {
  var newReq = req;
  if (!req.url.endsWith('.svg')) {
    newReq = req.clone({ url: environment.backendUrl + req.url, withCredentials: true });
  }
  return next(newReq);
};
